import { DistributorRole, UserRole } from "./UserRole";

export enum Realm {
  Distributor = "dist",
  Internal = "internal",
  FreightForwarder = "freight-forwarder",
  Supplier = "supplier",
}

export const validRealms: Record<UserRole, readonly Realm[]> = {
  // internal roles
  "read-only": [Realm.Internal],
  creative: [Realm.Internal],
  field1: [Realm.Internal],
  field2: [Realm.Internal],
  purchaser: [Realm.Internal, Realm.Distributor],
  compliance: [Realm.Internal],
  central: [Realm.Internal, Realm.Distributor],
  super: [Realm.Internal, Realm.Distributor],
  "select-purchaser": [Realm.Internal],
  // supplier roles
  supplier: [Realm.Supplier],
  "planning-tool-supplier": [Realm.Supplier],
  // freight forwarder roles
  "freight-forwarder": [Realm.FreightForwarder],
  // distributor roles
  [DistributorRole.DistributorOrderer]: [Realm.Distributor],
  [DistributorRole.DistributorAdmin]: [Realm.Distributor],
  [DistributorRole.Gallo]: [Realm.Distributor],
};
